<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-clock-outline" 
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <emc-calendar-time-picker dense @onSelect="selectHour" :error="!!errors.start" :errors="errors.start" :time.sync="model.start" label="Início*" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <emc-calendar-time-picker dense :error="!!errors.end" :errors="errors.end" :time.sync="model.end" label="Fim*" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-shift
                                :model.sync="model.shift_id"
                                :error="errors.length > 0"  
                                :errors="errors.shift_id"
                                label="Turno*"
                                :show-all="false"
                                dense
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-text-field text-helper="Número de aulas semanais consideradas na elaboração do horário" dense :error-messages="errors.number_of_classes" v-model="model.number_of_classes" label="*Nº Aulas" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field text-helper="Código para agrupar os horários e exibir como opção única de início e fim na tela de cadastro da disponibilide" dense :error-messages="errors.group" v-model="model.group" label="Agrupamento" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field dense code :error-messages="errors.code" v-model="model.code" label="Código"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <sys-select-hour-group
                                :model.sync="model.groups"
                                :error="errors.length > 0"  
                                :errors="errors.groups"
                                label="Grupo de Horário*"
                                multiple
                                required
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <s-switch text-helper="Exibir horário como opção na tela de cadastro da disponibilidade" inset v-model="model.to_availability" label="Disponibilidade" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <s-switch text-helper="Considerar horário no momento da alocação automática de horário" inset v-model="model.to_time_table" label="Horário Dinâmico" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-switch inset v-model="model.active" label="Ativo"></v-switch>
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterHour",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                
                if(!this.model.id){
                    this.model.active = true;
                    this.model.number_of_classes = 1;
                }
                    
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Horários"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('hour', ['ActionUpdateHour', 'ActionCreateHour']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            if(edit) {
                this.ActionUpdateHour(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateHour(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

        selectHour(val){
            
            if(this.model && this.model.id){
                return;
            }
            
            const [hour, minute] = val.split(':');
            var hourInt = parseInt(hour);
            
            if(hourInt >= 18){
                this.model.shift_id = 3;
            }else if(hourInt >= 12){
                this.model.shift_id = 2;
            }else{
                this.model.shift_id = 1;
            }
        }

    }
}
</script>